<gridster #meGridster [options]="options" width="100%" height="100%" 
 style="background: unset">
  <gridster-item [item]="item" 
  [ngClass]="{'notshadowed': notshadowed(item)}" 
  *ngFor="let item of tabWidgets" >
    <widget-comp
      [style.display]="doHide(item)"
      [model]="model"
      [templatingMode]="false"
      [itemParent]="currentTab"
      [gridsterConfig]="getRealVOFromGridsterLimitation(item)"
      [dataEnable]="false"
      [configureEnable]="false"
      [trashEnable]="false"
    ></widget-comp>
  </gridster-item>
</gridster>
